
import { safetyTips } from '../../../mocks/transportationPage';

export default function SafetyTipsSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-amber-100 text-amber-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide mb-4">
            Stay Safe
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Travel Safety Tips</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Keep these tips in mind for a safe and enjoyable experience getting around Roseville.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {safetyTips.map((tip, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all text-center"
            >
              <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className={`${tip.icon} text-2xl text-amber-600`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">{tip.title}</h3>
              <p className="text-gray-600 text-sm">{tip.description}</p>
            </div>
          ))}
        </div>

        {/* Emergency Contact */}
        <div className="mt-12 bg-white rounded-2xl p-8 shadow-sm border border-amber-100">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center space-x-4">
              <div className="w-14 h-14 bg-rose-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-alarm-warning-line text-2xl text-rose-600"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Emergency? Call 911</h3>
                <p className="text-gray-600 text-sm">
                  For non-emergency transit issues, contact Roseville Transit directly
                </p>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:9167457560"
                className="flex items-center justify-center space-x-2 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                <span>(916) 745-7560</span>
              </a>
              <a
                href="https://www.roseville.ca.us/government/departments/public_works/roseville_transit"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 bg-gray-900 hover:bg-gray-800 text-white px-6 py-3 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                <span>Transit Website</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
